module.exports = function negotiateSetLastConfirmed(events) {
	for(var i = events.length - 1; i >= 0; --i) {
        if(!events[i].isActual) continue;

        events[i].lastConfirmed = true;
        break;
    }
};